import { throttle } from 'lodash-es';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import getContext from 'recompose/getContext';
import toClass from 'recompose/toClass';
import { scroll } from '../actionCreators';
import ScrollableArea from '../components/ScrollableArea';
import { SCREEN_LAYER } from '../constants/userTest';
import { getScreenStyles, isRecording } from '../selectors';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    var screenStyles = getScreenStyles(state, isCurrentScreen);
    return {
        height: screenStyles.scrollableAreaHeight,
        width: screenStyles.scrollableAreaWidth,
        padding: screenStyles.scrollableAreaPadding,
        isScrollable: screenStyles.isScrollableAreaScrollable,
        imageWidth: screenStyles.imageWidth,
        imageHeight: screenStyles.imageHeight,
        isMobile: state.deviceDetection.isMobile,
        isIOS: state.deviceDetection.isIPad || state.deviceDetection.isIPhone,
        isRecording: isRecording(state),
        isFirstClick: state.project.isFirstClick,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        // if ownProps is used this needs to be hoisted out of here as it will be recreated every time
        // a prop changes
        onScroll: throttle(function (scrollLeft, scrollTop, screenID) {
            return dispatch(scroll(SCREEN_LAYER, scrollLeft, scrollTop, screenID));
        }, 50),
    };
}
export default compose(toClass, getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps, mapDispatchToProps))(ScrollableArea);
